<!--
 * @Description:修改登录密码页面，由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-20 18:38:51
 * @LastEditors: luoshoufeng@szkingdom.com
-->

<template>
    <div>
        <div :class="'bizcomp-change-lpwd bizcomp ' + className">
            <change-pwd :way="way" />
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import changePwd from "@/components/acctInfo/changePwdDc.vue";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";

export default {
    name: "ChangeLpwd",
    components: {
        changePwd,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            way: "login",
            warningHtml: ""
        };
    },
    mounted() {
        this.warningHtml = warningHtml.warningHtml2;
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.bizcomp-change-lpwd {
}
</style>
